import { render, staticRenderFns } from "./loginPassowrd.vue?vue&type=template&id=5c2b0cf3&scoped=true"
import script from "./loginPassowrd.vue?vue&type=script&lang=js"
export * from "./loginPassowrd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b0cf3",
  null
  
)

export default component.exports